"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.InfoCircleWrapper = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1)
}));
const InfoCircleWrapper = exports.InfoCircleWrapper = (0, _mui.styled)('button')({
  background: 'inherit',
  border: 'none',
  color: 'inherit',
  cursor: 'pointer',
  padding: 0
});
